import { useMutation, useQuery } from "@tanstack/react-query";
import { APIErrorResponse } from "src/types/generic";
import apiClient from "../apiClient";

interface IParams {
  page?: number;
  bank?: "alrajhi";
  reference_number?: string;
  //   order_reference_number?: string;
  //   is_matched?: string;
  //   start_date?: string | number;
  //   end_date?: string | number;
}

export const useGetMatchingBanksList = (params: IParams) =>
  useQuery<any, APIErrorResponse, any>({
    queryKey: [
      "get-matching-banks-list",
      params.page,
      params.bank,
      params.reference_number,
      //   params.order_reference_number,
      //   params.is_matched,
      //   params.start_date,
      //   params.end_date,
    ],
    queryFn: async () => {
      return apiClient.get(`/api/bankMatchings`, { params });
    },
    // enabled:
    //   (!!params.start_date && !!params.end_date) ||
    //   (!params.start_date && !params.end_date),
  });

export const useImportBanksMatchingMutation = () =>
  useMutation<void, APIErrorResponse, FormData>({
    mutationFn: async (data) => {
      return apiClient.post(`/api/bankMatchings`, data);
    },
  });

export const useDeleteBankMatchingMutation = () =>
  useMutation<void, APIErrorResponse, number>({
    mutationFn: async (id) => {
      return apiClient.delete(`/api/bankMatchings/${id}`);
    },
  });

interface IMatchOrdersParams {
  page?: number;
  bank_matching_id: number;
  is_matched?: number; // 0 | 1
}

export const useGetMatchingBankTransactions = (params: IMatchOrdersParams) =>
  useQuery<any, APIErrorResponse, any>({
    queryKey: [
      "get-matching-bank-trans-list",
      params.page,
      params.bank_matching_id,
      params.is_matched,
    ],
    queryFn: async () => {
      return apiClient.get(`/api/bankTransactionMatchings`, { params });
    },
  });

// for search
export const useGetBankTransactionsMatches = (params: {
  bank_matching_id: number;
}) =>
  useQuery<any, APIErrorResponse, any>({
    queryKey: ["get-bank-trans-matches", params.bank_matching_id],
    queryFn: async () => {
      return apiClient.get(`/api/bankPayments`, { params });
    },
  });

interface IBody {
  bankTransId: number;
  diff: number;
  note: string;
  bankPaymentsIds: number[];
}

export const useUpdateBankMatchingMutation = () =>
  useMutation<void, APIErrorResponse, IBody>({
    mutationFn: async (data) => {
      const { bankTransId, ...rest } = data;
      return apiClient.put(
        `/api/bankTransactionMatchings/${bankTransId}`,
        rest
      );
    },
  });

export const useDownloadBankMatchingTransactions = (params: { id: number }) =>
  useQuery<any, APIErrorResponse, any>({
    queryKey: ["get-account-3rd-eye-report", params.id],
    queryFn: async () => {
      return apiClient.get(
        `/api/bankTransactionMatchings/download?bank_matching_id=${params.id}`
      );
    },
    enabled: false,
    gcTime: 0,
  });
